import { FormEvent, useState } from 'react'
import { gradeSubmission, type AssignmentSubmission } from '@/lib/submissions'

interface GradeFormProps {
  submission: AssignmentSubmission
  onGraded: (record: AssignmentSubmission) => void
}

function GradeForm({ submission, onGraded }: GradeFormProps) {
  const [score, setScore] = useState(submission.score != null ? String(submission.score) : '')
  const [feedback, setFeedback] = useState(submission.feedback || '')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    const value = Number(score)
    if (!Number.isFinite(value)) {
      setError('Escribe una calificación numérica.')
      return
    }
    setError('')
    setBusy(true)
    try {
      const record = await gradeSubmission(submission._id, value, feedback)
      onGraded(record)
    } catch (err) {
      console.error('No se pudo calificar:', err)
      setError('No se pudo guardar la nota. Comprueba que tu cuenta es administradora.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <form onSubmit={onSubmit} className="mt-3 grid gap-2 sm:grid-cols-[7rem_1fr_auto]">
      <label className="block text-xs">
        Nota
        <input
          type="number"
          step="0.1"
          value={score}
          onChange={(event) => setScore(event.target.value)}
          className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-2 py-1.5 text-sm"
        />
      </label>
      <label className="block text-xs sm:col-span-1">
        Comentario
        <input
          value={feedback}
          onChange={(event) => setFeedback(event.target.value)}
          className="mt-1 w-full border border-[#1E3A5F]/20 bg-transparent px-2 py-1.5 text-sm"
        />
      </label>
      <button type="submit" disabled={busy} className="self-end bg-[#1E3A5F] px-3 py-2 text-sm text-[#F4EFE6] disabled:opacity-50">
        {busy ? 'Guardando…' : 'Calificar'}
      </button>
      {error ? <p className="text-xs text-[#C41E3A] sm:col-span-3">{error}</p> : null}
    </form>
  )
}

export default GradeForm
